import {
    DisplayAmount,
    ReadMore,
    ToggleLocation,
} from '@eventbrite/eds-read-more';
import { gettext } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';
import './TicketDescription.scss';

export interface TicketDescriptionProps {
    collapsedDisplayAmount?: DisplayAmount | null;
}

const TicketDescription: FunctionComponent<TicketDescriptionProps> = ({
    children,
    collapsedDisplayAmount = null,
}) => {
    if (!children) {
        return null;
    }

    const descriptionWithRequiredReadMoreControls = collapsedDisplayAmount ? (
        <ReadMore
            toggleLocation={ToggleLocation.bottom}
            collapsedLinkText={gettext('See more')}
            expandedLinkText={gettext('See less')}
            collapsedDisplayAmount={collapsedDisplayAmount}
        >
            {children}
        </ReadMore>
    ) : (
        children
    );

    return (
        <div
            className="ticket-description eds-text-color--grey-600 eds-text-bm"
            data-testid="ticket-description"
        >
            {descriptionWithRequiredReadMoreControls}
        </div>
    );
};

export default TicketDescription;
